import { render } from "./NavbarSlider.vue?vue&type=template&id=25bfd79c&scoped=true&ts=true"
import script from "./NavbarSlider.vue?vue&type=script&lang=ts"
export * from "./NavbarSlider.vue?vue&type=script&lang=ts"

import "./NavbarSlider.vue?vue&type=style&index=0&id=25bfd79c&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bfd79c"]])

export default __exports__